
import { defineComponent } from "vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import EnumControl from "@/components/controls/base/EnumControl.vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";
import DecimalControl from "@/components/controls/base/DecimalControl.vue";
import DxTextArea from "devextreme-vue/text-area";
import DxButton from "devextreme-vue/button";
import CatalogueSelectControl from "@/components/controls//base/CatalogueSelectControl.vue";
import TwoAxleTractorSingleAxleSemitrailer from "./TwoAxleTractorSingleAxleSemitrailer.vue"
import TwoAxleTractorTwoAxleSemitrailer from "./TwoAxleTractorTwoAxleSemitrailer.vue"
import TwoAxleTractorThreeAxleSemitrailer from "./TwoAxleTractorThreeAxleSemitrailer.vue"
import TwoAxleTractorFourAxleSemitrailer from "./TwoAxleTractorFourAxleSemitrailer.vue"
import ThreeAxleTractorSingleAxleSemitrailer from "./ThreeAxleTractorSingleAxleSemitrailer.vue"
import ThreeAxleTractorTwoAxleSemitrailer from "./ThreeAxleTractorTwoAxleSemitrailer.vue"
import ThreeAxleTractorThreeAxleSemitrailer from "./ThreeAxleTractorThreeAxleSemitrailer.vue"
import ThreeAxleTractorFourAxleSemitrailer from "./ThreeAxleTractorFourAxleSemitrailer.vue"
import { TractorType } from "./TractorType"
import { SemitrailerType } from "./SemitrailerType"
import { Collapse } from 'bootstrap'

export default defineComponent({
  components: {
    EnumControl,
    IntegerControl,
    DecimalControl,
    DxTextArea,
    DxButton,
    CatalogueSelectControl,
    TwoAxleTractorSingleAxleSemitrailer,
    TwoAxleTractorTwoAxleSemitrailer,
    TwoAxleTractorThreeAxleSemitrailer,
    TwoAxleTractorFourAxleSemitrailer,
    ThreeAxleTractorSingleAxleSemitrailer,
    ThreeAxleTractorTwoAxleSemitrailer,
    ThreeAxleTractorThreeAxleSemitrailer,
    ThreeAxleTractorFourAxleSemitrailer,
  },
  mixins: [mountComponentMixin],
  props: {
    model: { required: true },
    validationGroup: { required: true },
  },
  computed: {
    twoAxleTractor(): any {
      return this.tractorType == TractorType.TwoAxleTractor;
    },
    threeAxleTractor(): any {
      return this.tractorType == TractorType.ThreeAxleTractor;
    },
    singleAxleSemitrailer(): any {
      return this.semitrailerType == SemitrailerType.SingleAxleSemitrailer;
    },
    twoAxleSemitrailer(): any {
      return this.semitrailerType == SemitrailerType.TwoAxleSemitrailer;
    },
    threeAxleSemitrailer(): any {
      return this.semitrailerType == SemitrailerType.ThreeAxleSemitrailer;
    },
    fourAxleSemitrailer(): any {
      return this.semitrailerType == SemitrailerType.FourAxleSemitrailer;
    },
  },
  created() {
    this.modelLocal = this.model;
    if (!this.modelLocal.tractorType)
      this.modelLocal.tractorType = TractorType.TwoAxleTractor;
    if (!this.modelLocal.semitrailerType)
      this.modelLocal.semitrailerType = SemitrailerType.SingleAxleSemitrailer;
  },
  methods: {
    onSwitchChange() {
      this.isSettingsOpen = !this.isSettingsOpen;
      this.$emit("changeSettingsVisibility", this.isSettingsOpen);
    },
    onTractorTypeChange(){
      this.tractorType = this.modelLocal.tractorType;
      if (this.firstTractorDisplay)
        this.firstTractorDisplay = false;
      else
        this.resetValues();
    },
    onSemitrailerTypeChange(){
      this.semitrailerType = this.modelLocal.semitrailerType;
      if (this.firstSemitrailerDisplay)
        this.firstSemitrailerDisplay = false;
      else
        this.resetValues();
    },
    resetValues(){
      for (var key in this.modelLocal) {
        switch(key) {
          case "id":
          case "length":
          case "width":
          case "height":
          case "loadCapacity":
          case "requisiteWeight":
          case "loadStatThreshold":
          case "gapId":
          case "displacementId":
          case "transportType":
          case "tractorType":
          case "semitrailerType":
            break;
          default:
            if (typeof this.model[key] == "number")
              this.modelLocal[key] = 0;
        }
      }
    },
    saveData(e: any) {
      let result = e.validationGroup.validate();
      if (!result.isValid && this.isSettingsOpen == false){
        this.isSettingsOpen = true;
        this.$emit("changeSettingsVisibility", this.isSettingsOpen);
        new Collapse(this.$refs.collapseTractor, { toggle: true })
      }
    },
  },
  data() {
    return {
      isSettingsOpen: false,
      firstSemitrailerDisplay: true,
      firstTractorDisplay: true,
      modelLocal: null,
      tractorType: null,
      semitrailerType: null,
    };
  },
});
